export const AWS_ACCOUNT_ID = '982619301361';
export const AWS_PROFILE = 'matthis';
export const AWS_REGION = 'eu-west-3';
export const DEPLOY_BUCKET = 'food-deploy-devs-20250921063405071800000002';
export const ENV_NAME = 'devs';
export const IS_RUNNING_LOCALLY = false;
export const LOCALHOST = '';
export const NUTRI_DB_BUCKET = 'food-nutri-db-devs-20250921080816822200000001';
export const WEBSITE_BACKEND_FUNCTION_NAME = 'food-website_backend-devs';
export const WEBSITE_BACKEND_URL = 'https://food.matthis.link';
export const WEBSITE_FRONTEND_URL = 'https://food-statics.matthis.link';

// ------------------------------------------------------------
// Terraform output for devs
// ------------------------------------------------------------
// export const AWS_ACCOUNT_ID = "982619301361";
// export const AWS_PROFILE = "matthis";
// export const AWS_REGION = "eu-west-3";
// export const DEPLOY_BUCKET = "food-deploy-devs-20250921063405071800000002";
// export const NUTRI_DB_BUCKET = "food-nutri-db-devs-20250921080816822200000001";
// export const WEBSITE_BACKEND_FUNCTION_NAME = "food-website_backend-devs";
// export const WEBSITE_BACKEND_URL = "https://food.matthis.link";
// export const WEBSITE_FRONTEND_URL = "https://food-statics.matthis.link";
// ------------------------------------------------------------
